import { useNotifications } from 'hooks/useNotifications';
import { Navigate, Outlet } from 'react-router';
import { AppRoutes } from 'UI/router';

interface ProtectedLayoutOutletProps {
  authed?: boolean | null;
}

export function ProtectedLayoutOutlet(props: ProtectedLayoutOutletProps): React.ReactElement {
  const { authed } = props;

  useNotifications(authed);

  if (!authed) {
    return <Navigate to={AppRoutes.Auth.AdminLogin()} replace={true} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
}
